/**
 * NotaVera feature flags (N1), mirroring apps/api/src/common/features.ts. Inherited QXM-only modules are hidden — their
 * menus, routes and Help pages — but their code stays for later sprints. The API refuses them anyway (404 FEATURE_OFF).
 * A dev build can switch modules back on with VITE_FEATURE_MODULES=controlled,capa (must match the API's FEATURE_MODULES).
 *
 * N9 cleanup (web only — the API keeps these engine routes, still guarded by permissions): the QXM document library
 * (documents, cabinets, upload, search, share links, matching rules, import), QXM e-Sign requests, records retention /
 * holds / disposition / approvals, QXM reports and support sessions (platform staff reach notarial data only through a
 * logged break-glass grant, FR-PRIV-04). Notarial documents live in sessions, the book and the ENA portal instead.
 */
export const MODULE_KEYS = ['controlled', 'exceptions', 'compliance', 'capa', 'controls', 'physical', 'ai', 'evidencePack', 'redaction', 'mobile', 'documentLinks', 'library', 'esign', 'records', 'qxmReports', 'support'] as const;
export type ModuleKey = (typeof MODULE_KEYS)[number];

const isKey = (k: string): k is ModuleKey => (MODULE_KEYS as readonly string[]).includes(k);

/** Pure: the switched-on modules from a comma list (exported for tests). */
export function parseModules(list: string | undefined): Set<ModuleKey> {
  return new Set((list ?? '').split(',').map((s) => s.trim()).filter(isKey));
}

const ON = parseModules((import.meta.env as Record<string, string | undefined>).VITE_FEATURE_MODULES);

export const moduleOn = (key: ModuleKey | undefined): boolean => !key || ON.has(key);
